import { render, staticRenderFns } from "./site-size-config.vue?vue&type=template&id=23197bfc"
import script from "./site-size-config.vue?vue&type=script&lang=ts"
export * from "./site-size-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports